import { SYSTEM_SERVER_INFO } from '@/store/actions/system';

import systemApi from '@/api/system';

/* eslint-disable camelcase */


const state = {
  clientVersion: 'v2.0.2',
  serverVersion: '',
  externalUrl: ''
};

const getters = {
  getLabelUrl: (state) => (wine) => {
    if (!wine || !wine.data || !wine.data.label_url) {
      return '';
    }

    return `${state.externalUrl}/public/uploads/wines/${wine.wine_id}/${wine.data.label_url}`;
  }
};

const actions = {
  async [SYSTEM_SERVER_INFO] ({ commit }) {
    commit(SYSTEM_SERVER_INFO, await systemApi.info());
  }
};

const mutations = {
  [SYSTEM_SERVER_INFO] (state, info) {
    Object.assign(state, info);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
